module.exports = require('./AuthenticationService-anonymous')


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/plugin?auth-type!./common/js/src/edge/api/gw-portals-auth-js/AuthenticationService.js
// module id = 396
// module chunks = 0